import type { StatusId, PriorityId, ProjectStatus } from "./types";

export const STATUSES: {
  id: StatusId;
  name: string;
  color: string;
  group: "backlog" | "unstarted" | "started" | "completed" | "canceled";
}[] = [
  { id: "backlog", name: "Backlog", color: "#8a8f98", group: "backlog" },
  { id: "todo", name: "Todo", color: "#b4bcd0", group: "unstarted" },
  { id: "in_progress", name: "In Progress", color: "#f2c94c", group: "started" },
  { id: "in_review", name: "In Review", color: "#a55cff", group: "started" },
  { id: "done", name: "Done", color: "#26b24b", group: "completed" },
  { id: "canceled", name: "Canceled", color: "#62666d", group: "canceled" },
];

export const PRIORITIES: { id: PriorityId; name: string; short: string }[] = [
  { id: 0, name: "No priority", short: "—" },
  { id: 1, name: "Urgent", short: "U" },
  { id: 2, name: "High", short: "H" },
  { id: 3, name: "Medium", short: "M" },
  { id: 4, name: "Low", short: "L" },
];

export const PROJECT_STATUSES: { id: ProjectStatus; name: string; color: string }[] = [
  { id: "backlog", name: "Backlog", color: "#8a8f98" },
  { id: "planned", name: "Planned", color: "#4ea7fc" },
  { id: "in_progress", name: "In Progress", color: "#f2c94c" },
  { id: "paused", name: "Paused", color: "#f2994a" },
  { id: "completed", name: "Completed", color: "#26b24b" },
  { id: "canceled", name: "Canceled", color: "#62666d" },
];

export const LABEL_COLORS = [
  "#eb5757",
  "#f2994a",
  "#f2c94c",
  "#26b24b",
  "#4ea7fc",
  "#a55cff",
  "#ff8ae2",
  "#4cc3c7",
  "#8a8f98",
];

export const USER_COLORS = [
  "#eb5757",
  "#f2994a",
  "#f2c94c",
  "#26b24b",
  "#4ea7fc",
  "#5e6ad2",
  "#a55cff",
  "#ff8ae2",
  "#4cc3c7",
];

export const TEAM_ICONS = ["◆", "◇", "▲", "●", "■", "★", "✦", "◉"];
